import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  slot: {
    padding: '12px 0px',
    background: theme.palette.primary.light,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'all ease 0.3s',
    border: `1px solid ${theme.palette.primary.light}`,
    borderRadius: 6,
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgba(19, 45, 74, 0.04)',
    width: '100%',
    '&:hover': {
      borderColor: theme.palette.primary.main,
      transition: 'all ease 0.3s',
      '& $slotInner': {
        color: theme.palette.primary.main,
        transition: 'all ease 0.3s',
      },
    },
  },
  slotInner: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.common.black,
    transition: 'all ease 0.3s',
  },
}))

export default useStyles
